const getTranslateFunc = function () {
  let i18n;

  try {
    i18n = require('@/lang/i18n.js').default;
  } catch (error) {
    // console.log(error);
  }

  return i18n
    ? (translateAlias) => i18n.t(translateAlias)
    : (translateAlias) => translateAlias;
};

const getTranslate = getTranslateFunc();

//Должен называться так же как и в modules_components_obj
let module_name = 'FastLineLite';

let module_settings = {
  module_name,
};
//Корневой урл модуля
let module_alias = 'fast_line_lite';

//Список разрешений модуля
module_settings.permits = {
  front: {
    //Отображение пунктов меню
    fast_line_lite_show_menu_item: {
      description: 'Отображать в меню пункт Fast Line Pro',
    },
    fast_line_lite_show_tab_item: {
      description: 'Отображать таб Fast Line Pro',
    },
  },

  back: {}
};

//Пункты в меню
module_settings.menu_items = [

];

//Табы модуля
module_settings.tabs_items = {};

module_settings.tabs_items[module_name] = {
  use_tabs: true,
  tabs_items: [

  ],
};

//Подключенные компоненты
module_settings.components = [
  {
    name: module_name,
    path: 'Component/FastLineLite.vue',
  },
];

//Экспорт для vue и для node
module.exports = { module_settings };
module.exports.default = { module_settings };
